<template>
  <div data-view="link-to-form">
    <h5>
      {{ $t('link_to') }} <span>{{ $t('optional') }}</span>
    </h5>

    <v-autocomplete
      v-model="selectedCountries"
      :items="method === 'invoice' ? enabledPromoCountries : linkedCountries"
      :label="$t('select_country')"
      :placeholder="$t('select_and_link_country_to_this_account')"
      item-title="name"
      item-value="code"
      return-object
      chips
      closable-chips
      multiple
      hide-selected
      :disabled="isDisabled"
      @update:model-value="onChangeSelectedCountries"
    >
      <template #chip="{ item, attrs, selected }">
        <v-chip
          v-if="item === Object(item)"
          v-bind="attrs"
          :model-value="selected"
          color="primary"
          variant="flat"
          :closable="!isPersistent(item.raw)"
          label
          @click:close="clearCountry(item)"
        >
          <span class="chip-item">
            {{ item.raw.name }}
          </span>
        </v-chip>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
  export default {
    props: {
      billingAccount: {
        type: Object,
        required: true,
      },
      linkCountries: {
        type: Function,
        default: () => {},
      },
      isDisabled: {
        type: Boolean,
        default: false,
      },
      method: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        selectedCountries: [],
      };
    },
    computed: {
      user() {
        return this.$store.getters['auth/user'];
      },
      enabledPromoCountries() {
        return this.$store.getters['businessUsers/enabledPromoCountries'];
      },
      linkedCountries() {
        return this.$store.getters['networks/linkedCountries'];
      },
    },
    watch: {
      billingAccount(nextItem) {
        this.clear();
        this.extractLinkedCountries(nextItem);
      },
    },
    created() {
      const {
        billingAccount,
        getEnabledCountriesForPromotion,
        getLinkedCountries,
        extractLinkedCountries,
      } = this;

      getLinkedCountries();
      getEnabledCountriesForPromotion();
      extractLinkedCountries(billingAccount);
    },
    methods: {
      getEnabledCountriesForPromotion() {
        return this.$store.dispatch('businessUsers/getEnabledCountriesForPromotion');
      },
      getLinkedCountries() {
        return this.$store.dispatch('networks/getLinkedCountries');
      },
      extractLinkedCountries(item) {
        const { linked_countries, in_review_countries } = item;

        if (item.payment_method === 'network' && linked_countries && in_review_countries) {
          this.selectedCountries = [...linked_countries, ...in_review_countries];
          return;
        }

        if (linked_countries) {
          this.selectedCountries = linked_countries;
        }
      },
      isPersistent(item) {
        const { billingAccount } = this;

        if (
          billingAccount &&
          billingAccount.in_review_countries &&
          billingAccount.in_review_countries.length
        ) {
          const { in_review_countries, linked_countries } = billingAccount;
          const allCountries = [...in_review_countries, ...linked_countries];
          const flatCountries = allCountries.map((c) => c.code);
          return flatCountries.includes(item.code);
        }

        if (
          billingAccount &&
          billingAccount.linked_countries &&
          billingAccount.linked_countries.length
        ) {
          const { linked_countries } = billingAccount;
          const flatCountries = linked_countries.map((c) => c.code);
          return flatCountries.includes(item.code);
        }

        return false;
      },
      onChangeSelectedCountries() {
        this.linkCountries(this.selectedCountries);
      },
      clearCountry(country) {
        this.selectedCountries.splice(
          this.selectedCountries.findIndex((c) => c.code === country.value),
          1
        );
        this.linkCountries(this.selectedCountries);
      },
      clear() {
        this.selectedCountries = [];
      },
    },
  };
</script>

<style lang="scss">
[data-view='link-to-form'] {
  margin-top: 24px;
  padding: 16px;
  min-height: auto;
  background-color: rgba(var(--v-theme-on-surface), 0.06);
  border-radius: 4px;

  h5 {
    margin-bottom: 8px;
    font-size: 16px;
    color: #424242;

    .v-theme--dark & {
      color: rgb(var(--v-theme-on-surface));
    }

    span {
      font-size: 14px;
      font-weight: 400;
      color: #9e9e9e;
    }
  }

  .chip-item {
    color: white;
  }

  .v-icon {
    color: white;
  }
}
</style>
